<template>
    <div class="full-chat-w single-page-container">
        <div class="content-box col-sm-8 col-xs-12">
            <div class="element-wrapper">
                <h6 class="element-header">
                    Add Copy Desk Template
                </h6>
                <div class="element-box p-10">
                    <AddCopyTemplate :session-type="'copytemplate-add'" :channels="channels" :categories="categories" :headers="selectedHeaders" @stepInterface="onStepChange" @headerInterface="removeHeader" />
                </div>
            </div>
        </div>
        <div class="content-panel col-sm-4 col-xs-hidden middle ">
            <div class="content-panel-close">
                <i class="os-icon os-icon-close"></i>
            </div>
            <div class="element-wrapper" v-if="sideBarContent=='headers'">
                <h6 class="element-header">Headers</h6>
                <div class="element-box-tp">
                    <div class="input-search-w">
                        <input class="form-control rounded bright" v-model="headerSearch" placeholder="Search headers..." type="search">
                    </div>
                    <div class="users-list-w">
                        <div class="user-w" v-for="header in filteredHeaders">
                            <div class="user-avatar-w header-type">
                                <div class="user-avatar">
                                    <div :class="mapHeaderIcon(header.header_type)"></div>
                                </div>
                            </div>
                            <div class="user-name">
                                <h6 class="user-title">{{capitalize(header.header_name)}}</h6>
                                <div class="user-role">{{header.header_type}}</div>
                            </div>
                            <a class="user-action" @click="addHeader(header)">
                                <div class="fal fa-plus"></div>
                            </a>
                        </div>

                    </div>
                </div>
            </div>
            <div class="element-wrapper" v-else>
                <h6 class="element-header">Guide</h6>
                <div class="element-box-tp">
                    <div class="todo-list">
                        <a class="todo-item">
                            <div class="ti-info">
                                <div class="ti-header">Channel is required</div>
                            </div>
                        </a>
                        <a class="todo-item">
                            <div class="ti-info">
                                <div class="ti-header">Category is required</div>
                            </div>
                        </a>
                        <a class="todo-item">
                            <div class="ti-info">
                                <div class="ti-header">Atleast one visible header is required</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AddCopyTemplate from '@/components/common/Forms/AddCopyTemplate'
import CommonFunctions from '@/mixins/common-functions.js'

export default {
  mixins: [CommonFunctions],
  components: { AddCopyTemplate },
  data () {
    return {
      sideBarContent: 'others',
      channels: '',
      categories: '',
      headers: '',
      filteredHeaders: [],
      selectedHeaders: [],
      headerSearch: ''
    }
  },
  mounted () {
    this.getFormParameters()
  },
  methods: {
    getFormParameters () {
      var self = this

      const url = '/copydesk/templates/add/helper'
      this.$http
        .get(url, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.channels = response.data.channels
          self.categories = response.data.categories
          self.headers = self.filteredHeaders = response.data.headers
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: error.response.data || 'Something went wrong',
            show: true
          })
        })
    },
    addHeader (header) {
      this.selectedHeaders.push(header)
      this.$store.dispatch('updateToast', {
        text: 'Header added to template',
        show: true
      })
      this.updateHeader()
    },
    removeHeader (data) {
      for (var i = 0; i < this.selectedHeaders.length; i++) {
        if (
          this.selectedHeaders[i].id_copy_template_header ===
          data.id_copy_template_header
        ) {
          this.selectedHeaders.splice(i, 1)
          break
        }
      }
      this.$store.dispatch('updateToast', {
        text: 'Header removed to template',
        show: true
      })
      this.updateHeader()
    },
    updateHeader () {
      this.filteredHeaders = this.headers.filter(
        item =>
          !this.selectedHeaders.includes(item) &&
          item.header_name.indexOf(this.headerSearch) > -1
      )
    },
    onStepChange (data) {
      this.sideBarContent = data
    },
    mapHeaderIcon (header) {
      console.log(header)
      switch (header) {
        case 'text':
          return 'fal fa-font'
          break
        case 'textarea':
          return 'fal fa-align-left'
          break
        case 'dropdown':
          return 'fal fa-caret-down'
          break
        case 'dropdown_multiple':
          return 'fal fa-check-double'
          break
        case 'metric':
          return 'fal fa-tachometer'
          break
      }
    }
  },
  watch: {
    headerSearch () {
      this.updateHeader()
    }
  }
}
</script>

<style scoped>
.single-page-container {
  padding: 20px;
}
.content-panel {
  padding: 1rem;
}
</style>
